import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { QuickscanWidget } from '../QuickscanWidget'
import '../styles.css'

const rootElement = document.getElementById('wtta-quickscan-root')

if (!rootElement) {
  throw new Error('Missing #wtta-quickscan-root element in index.html')
}

createRoot(rootElement).render(
  <StrictMode>
    <QuickscanWidget />
  </StrictMode>,
)
